// tslint:disable
/**
 * Scorm API
 * Used for: - Manage SCORM - Import courses - Learning control 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Course } from '../models';
import { Scorm } from '../models';
import { ScormEdit } from '../models';
import { ScormImport } from '../models';
import { ScormList } from '../models';
/**
 * ScormApi - axios parameter creator
 * @export
 */
export const ScormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete SCORM.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScorm(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteScorm.');
            }
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change SCORM\'s title & description.
         * @param {string} id 
         * @param {ScormEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScorm(id: string, body: ScormEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editScorm.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editScorm.');
            }
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get SCORM.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScorm(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getScorm.');
            }
            const localVarPath = `/scorm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import SCORM course in system.
         * @param {string} id 
         * @param {ScormImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importScorm(id: string, body: ScormImport, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling importScorm.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling importScorm.');
            }
            const localVarPath = `/scorm/{id}/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list with SCORMs.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {'SCORM 1.2' | 'SCORM 2004'} [version] 
         * @param {string} [locale] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScorm(ids?: Array<string>, title?: string, companyId?: string, version?: 'SCORM 1.2' | 'SCORM 2004', locale?: string, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            const localVarPath = `/scorms`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload SCORM archive.
         * @param {string} companyId 
         * @param {string} diskId 
         * @param {any} file 
         * @param {string} title 
         * @param {string} path 
         * @param {string} description If field should be null, send \\\&#39;\\\&#39;.
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadScorm(companyId: string, diskId: string, file: any, title: string, path: string, description: string, locale?: string, options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling uploadScorm.');
            }
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling uploadScorm.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadScorm.');
            }
            // verify required parameter 'title' is not null or undefined
            if (title === null || title === undefined) {
                throw new RequiredError('title','Required parameter title was null or undefined when calling uploadScorm.');
            }
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling uploadScorm.');
            }
            // verify required parameter 'description' is not null or undefined
            if (description === null || description === undefined) {
                throw new RequiredError('description','Required parameter description was null or undefined when calling uploadScorm.');
            }
            const localVarPath = `/scorm`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (companyId !== undefined) { 
                localVarFormParams.append('companyId', companyId as any);
            }
    
            if (diskId !== undefined) { 
                localVarFormParams.append('diskId', diskId as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
            if (path !== undefined) { 
                localVarFormParams.append('path', path as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
            if (locale !== undefined) { 
                localVarFormParams.append('locale', locale as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScormApi - functional programming interface
 * @export
 */
export const ScormApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Delete SCORM.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScorm(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = ScormApiAxiosParamCreator(configuration).deleteScorm(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Change SCORM\'s title & description.
         * @param {string} id 
         * @param {ScormEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScorm(id: string, body: ScormEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scorm> {
            const localVarAxiosArgs = ScormApiAxiosParamCreator(configuration).editScorm(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get SCORM.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScorm(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scorm> {
            const localVarAxiosArgs = ScormApiAxiosParamCreator(configuration).getScorm(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Import SCORM course in system.
         * @param {string} id 
         * @param {ScormImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importScorm(id: string, body: ScormImport, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Course> {
            const localVarAxiosArgs = ScormApiAxiosParamCreator(configuration).importScorm(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get list with SCORMs.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {'SCORM 1.2' | 'SCORM 2004'} [version] 
         * @param {string} [locale] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScorm(ids?: Array<string>, title?: string, companyId?: string, version?: 'SCORM 1.2' | 'SCORM 2004', locale?: string, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScormList> {
            const localVarAxiosArgs = ScormApiAxiosParamCreator(configuration).listScorm(ids, title, companyId, version, locale, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Upload SCORM archive.
         * @param {string} companyId 
         * @param {string} diskId 
         * @param {any} file 
         * @param {string} title 
         * @param {string} path 
         * @param {string} description If field should be null, send \\\&#39;\\\&#39;.
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadScorm(companyId: string, diskId: string, file: any, title: string, path: string, description: string, locale?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scorm> {
            const localVarAxiosArgs = ScormApiAxiosParamCreator(configuration).uploadScorm(companyId, diskId, file, title, path, description, locale, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ScormApi - factory interface
 * @export
 */
export const ScormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Delete SCORM.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScorm(id: string, options?: any) {
            return ScormApiFp(configuration).deleteScorm(id, options)(axios, basePath);
        },
        /**
         * Change SCORM\'s title & description.
         * @param {string} id 
         * @param {ScormEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editScorm(id: string, body: ScormEdit, options?: any) {
            return ScormApiFp(configuration).editScorm(id, body, options)(axios, basePath);
        },
        /**
         * Get SCORM.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScorm(id: string, options?: any) {
            return ScormApiFp(configuration).getScorm(id, options)(axios, basePath);
        },
        /**
         * Import SCORM course in system.
         * @param {string} id 
         * @param {ScormImport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importScorm(id: string, body: ScormImport, options?: any) {
            return ScormApiFp(configuration).importScorm(id, body, options)(axios, basePath);
        },
        /**
         * Get list with SCORMs.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {'SCORM 1.2' | 'SCORM 2004'} [version] 
         * @param {string} [locale] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScorm(ids?: Array<string>, title?: string, companyId?: string, version?: 'SCORM 1.2' | 'SCORM 2004', locale?: string, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
            return ScormApiFp(configuration).listScorm(ids, title, companyId, version, locale, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * Upload SCORM archive.
         * @param {string} companyId 
         * @param {string} diskId 
         * @param {any} file 
         * @param {string} title 
         * @param {string} path 
         * @param {string} description If field should be null, send \\\&#39;\\\&#39;.
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadScorm(companyId: string, diskId: string, file: any, title: string, path: string, description: string, locale?: string, options?: any) {
            return ScormApiFp(configuration).uploadScorm(companyId, diskId, file, title, path, description, locale, options)(axios, basePath);
        },
    };
};

/**
 * ScormApi - object-oriented interface
 * @export
 * @class ScormApi
 * @extends {BaseAPI}
 */
export class ScormApi extends BaseAPI {
    /**
     * Delete SCORM.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public deleteScorm(id: string, options?: any) {
        return ScormApiFp(this.configuration).deleteScorm(id, options)(this.axios, this.basePath);
    }

    /**
     * Change SCORM\'s title & description.
     * @param {string} id 
     * @param {ScormEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public editScorm(id: string, body: ScormEdit, options?: any) {
        return ScormApiFp(this.configuration).editScorm(id, body, options)(this.axios, this.basePath);
    }

    /**
     * Get SCORM.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public getScorm(id: string, options?: any) {
        return ScormApiFp(this.configuration).getScorm(id, options)(this.axios, this.basePath);
    }

    /**
     * Import SCORM course in system.
     * @param {string} id 
     * @param {ScormImport} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public importScorm(id: string, body: ScormImport, options?: any) {
        return ScormApiFp(this.configuration).importScorm(id, body, options)(this.axios, this.basePath);
    }

    /**
     * Get list with SCORMs.
     * @param {Array<string>} [ids] 
     * @param {string} [title] 
     * @param {string} [companyId] 
     * @param {'SCORM 1.2' | 'SCORM 2004'} [version] 
     * @param {string} [locale] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'title' | 'createdAt' | 'updatedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public listScorm(ids?: Array<string>, title?: string, companyId?: string, version?: 'SCORM 1.2' | 'SCORM 2004', locale?: string, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
        return ScormApiFp(this.configuration).listScorm(ids, title, companyId, version, locale, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * Upload SCORM archive.
     * @param {string} companyId 
     * @param {string} diskId 
     * @param {any} file 
     * @param {string} title 
     * @param {string} path 
     * @param {string} description If field should be null, send \\\&#39;\\\&#39;.
     * @param {string} [locale] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScormApi
     */
    public uploadScorm(companyId: string, diskId: string, file: any, title: string, path: string, description: string, locale?: string, options?: any) {
        return ScormApiFp(this.configuration).uploadScorm(companyId, diskId, file, title, path, description, locale, options)(this.axios, this.basePath);
    }

}
